const model = {
  authenticated: false,
  user: null,
  checking: true,
  loggingIn: false,
  loggingOut: false,
  registerLoading: false,
  verifying: true,
  verified: false,
  verificationFailed: false,
  selectedProject: null,
  dashboardView: undefined,
  invitedUsers: [],
  invitationSuccess: false,
  options: {},
  sourceId: localStorage.getItem('source'),
};

export default model;
